module.exports = __webpack_public_path__ + "img/cloud.7f8f7c1.svg";